import Home from './Pages/Home';
export { NSAction } from './Action';
export * from './Data';
export { reducer } from './Store';
export const Pages = {
  Home
};
